import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const Title = styled(Typography)(() => ({
  display: "flex",
  color: "white",
  textAlign: "center",
  textShadow: "5px 5px 5px black",
  fontSize: 30,
  fontFamily: "Source Sans Pro",
}));

export { Title };
